import { render } from "./productComponent.vue?vue&type=template&id=5aba41ac&scoped=true"
import script from "./productComponent.vue?vue&type=script&lang=js"
export * from "./productComponent.vue?vue&type=script&lang=js"

import "./productComponent.vue?vue&type=style&index=0&id=5aba41ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aba41ac"]])

export default __exports__